"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const url_parse_1 = __importDefault(require("url-parse"));
exports.CDN_URL_PROTOCOL = 'seneca-image-cdn';
function getCdnUrl(imageUrl) {
    const parsedUrl = new url_parse_1.default(imageUrl);
    parsedUrl.set('protocol', exports.CDN_URL_PROTOCOL);
    parsedUrl.set('slashes', '//');
    parsedUrl.set('hostname', '');
    parsedUrl.set('port', undefined);
    return parsedUrl.toString();
}
exports.getCdnUrl = getCdnUrl;
